<template>
  <LivePlay></LivePlay>
</template>

<script>
  import LivePlay from '@/page/modules/livePlay/detail'
  export default {
    components: { LivePlay }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/entrain/liveplay/model.vue